export default "__VITE_ASSET__DM5IikbY__"